window.ReferencesForm = function(scope, hUser, source) {
  var self = this;
  var formName = "references-form";
  self.name = formName;
  self.status = {completed: false};
  self.source = source;
  var _protected = BaseForm.call(self, formName, scope);

  var referencesForDelete = [];
    self.data.references = [{}];
    
    self.isOptional = function () {
        return !self.type;
    };

  self.load = () => {
      let defer = $q.defer();
      let promises = [];
      const shouldLoadReferences = self.source !== 'JOB_APPLY' || hUser.isLoggedIn();

      if (shouldLoadReferences) {
          promises.push(ReferenceAPI.loadReferences());
      }

      $q.all(promises)
          .then((data) => {
              self.data.references = [];

              if (data?.length > 0) {
                  if (self.source !== 'JOB_APPLY') {
                      data[0].forEach((ele) => {
                          if (ele.years_known_for) {
                              ele.years_known_for += "";
                          } else {
                              ele.years_known_for = "0";
                          }
                      });
                  }

                  self.data.references = data[0]?.length > 0 ? data[0] : [{}];
              } else if (!self.isOptional()) {
                  self.data.references.push({});
              }
              defer.resolve();
              setTimeout(() => {
                  self.calculateCompleteness();
              }, 1000);
          });

      return defer.promise;
  };

  self.save = function() {
    var defer = $q.defer();

    ReferenceAPI.addOrUpdate(self.data.references, referencesForDelete, source)
        .then(function(res) {
          defer.resolve(res);
        },
        function(err) {
          defer.reject(err);
        });

    return defer.promise;
  };

  self.validator.afterValidation(function () {
    self.calculateCompleteness();
  });

  self.calculateCompleteness = function () {

    self.status.completed = self.validator.validateWithoutError();

    if (scope) {
      try {
        scope.$digest();
      }
      catch (e) { /* Do Nothing */ }
    }
    else {
      console.warn("Scope is not here: form name: ", self.name);
    }
  };

  self.removeReference = function(index) {
    self.validator.clearValidate(index);

    if (self.data.references[index] && self.data.references[index].id) {
      referencesForDelete.push(self.data.references[index]);
    }

    self.data.references.splice(index, 1);
    setTimeout(function () {
      self.calculateCompleteness();
    }, 1000);
  }

  self.addReference = function() {
    self.data.references.push({years_known_for : 0});
    setTimeout(function () {
      self.calculateCompleteness();
    }, 1000);
  }

  self.load();
}
